import { useContext } from 'react'

import { AuthProviderContext } from './AuthProvider.context'

/**
 * The AuthProvider custom hook.
 */
export const useAuthorization = () => {
  const { userType } = useContext(AuthProviderContext)

  return { userType }
}
